import { render, staticRenderFns } from "./ExportacaoAEJ.vue?vue&type=template&id=6491ada1"
import script from "./ExportacaoAEJ.vue?vue&type=script&lang=js"
export * from "./ExportacaoAEJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports